import {
  LOGO_TYPE,
  NAVBAR_ALIGNMENT,
  NAVBAR_POSITION,
  NAVBAR_STYLE,
  NAVBAR_ITEM_TYPE,
  NAVBAR_DRAGGABLE_TYPE,
  DEFAULT_COLOR_NAME,
  DEFAULT_ACCENT_NAME,
  DEFAULT_TEXT_ON_ACCENT_NAME,
} from '@typedream/core';
import { ELEMENT_NAVBAR } from '../../pluginKeys';

// TODO(@ibedwi): fill with default value
export const getDefaultNavbarItemValue = () => ({});
export const getDefaultNavbarValue = () => ({
  children: [],
  type: ELEMENT_NAVBAR,
  logoImage: '🦄',
  logoType: LOGO_TYPE.EMOJI,
  logoTitle: 'Unicorn',
  logoScale: 0,
  alignment: NAVBAR_ALIGNMENT.CENTER,
  menu: [
    {
      title: 'Home',
      type: NAVBAR_ITEM_TYPE.LINK,
      color: DEFAULT_COLOR_NAME,
    },
    {
      title: 'About',
      type: NAVBAR_ITEM_TYPE.LINK,
      color: DEFAULT_COLOR_NAME,
    },
  ],
  endMenu: [
    {
      title: 'Sign Up',
      type: NAVBAR_ITEM_TYPE.BUTTON,
      background: DEFAULT_ACCENT_NAME,
      color: DEFAULT_TEXT_ON_ACCENT_NAME,
    },
  ],
  style: NAVBAR_STYLE.SHADOW,
  position: NAVBAR_POSITION.RELATIVE,
  isBlur: false,
});

export {
  LOGO_TYPE,
  NAVBAR_ALIGNMENT,
  NAVBAR_POSITION,
  NAVBAR_STYLE,
  NAVBAR_ITEM_TYPE,
  NAVBAR_DRAGGABLE_TYPE,
  DEFAULT_COLOR_NAME,
  DEFAULT_ACCENT_NAME,
  DEFAULT_TEXT_ON_ACCENT_NAME,
};
